import { BPMAnalyticsAPI } from 'api'
import { BPMChart } from 'components/Chart'
import { GroupByDate, GroupByDateType } from 'components/GroupByDate'
import { ArgumentAxis, Label, TickInterval } from 'devextreme-react/chart'
import * as React from 'react'
import { resultDateTransformer } from 'utils/date'

export const UsedCreditsChart: React.FunctionComponent = (props) => {
    const [groupDateBy, setGroupDateBy] = React.useState<GroupByDateType>('day')

    const toolbarItems = GroupByDate(groupDateBy, (selected) => {
        setGroupDateBy(selected)
    })
    return (
        <BPMChart {...props} title='Used Credits' type='bar'
            additionalParams={{ groupDateBy }}
            onRequestLoad={(options, signal) => {
                return resultDateTransformer(BPMAnalyticsAPI.get<any>('credit/used', options, signal))
            }} allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            toolBarItems={() => toolbarItems} series={{ name: 'Credits', valueField: 'count', argumentField: 'date' }}>
            <ArgumentAxis>
                <Label format={groupDateBy == 'month' ? 'month' : "shortDate"} />
                <TickInterval days={groupDateBy == 'day' ? 1 : undefined} weeks={groupDateBy == 'week' ? 1 : undefined} months={groupDateBy == 'month' ? 1 : undefined} />
            </ArgumentAxis>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Credit/charts/UsedCreditsChart.tsx